# frozen_string_literal: true

require_relative 'base'

module Engine
  module Action
    class Convert < Base
    end
  end
end
